import {Component, OnInit} from '@angular/core';

import {InscricaoComponent} from "../inscricao/inscricao.component";
import {URL_API} from '../constante';
import {Inscricao} from "../inscricao/inscricao";
import {InscricaoService} from "../inscricao/inscricao.service";


declare var jQuery: any;

@Component({
	selector: 'app-inscricao-detail',
	templateUrl: '../inscricao/inscricao.component.html',
	styleUrls: ['./inscricao-detail.component.css'],
	providers: [InscricaoService]
})
export class InscricaoDetailComponent extends InscricaoComponent implements OnInit {

	edit: boolean;
	carregado: boolean;
	inscricao: Inscricao;

	ngOnInit() {
		if (!this.islogged()) {
            this.router.navigateByUrl('acesso');
        } else {
			let id: number;
			this.route.params.subscribe(params => id = +params['id']);
			this.edit = false;
			this.inscricaoService.getInscricao(id).then(dados => this.setInscricao(dados));
		}											
	}

	setInscricao(dados: any) {
		this.inscricao = new Inscricao();
		this.inscricao = dados;
		this.carregado = true;
		
		if (!this.isAdmin() && this.inscricao.usuario_id != this.user_id)
			this.router.navigateByUrl('inicio');
	}
	
	link_arquivo(tipo: string): string {
		return  URL_API + '/documento/' + tipo + '/' + this.inscricao.id;
    }
	
	ngAfterViewChecked() {
		jQuery('#responsavel_false').prop('checked', this.inscricao.perfil_autoria_id == 1);
		jQuery('#responsavel_true').prop('checked', this.inscricao.perfil_autoria_id == 3);
		jQuery('#teatro_false').prop('checked', !this.inscricao.teatro);
		jQuery('#teatro_true').prop('checked', this.inscricao.teatro);
		jQuery('#cinema_false').prop('checked', !this.inscricao.cinema);
		jQuery('#cinema_true').prop('checked', this.inscricao.cinema);
		jQuery('#show_false').prop('checked', !this.inscricao.show);
		jQuery('#show_true').prop('checked', this.inscricao.show);
		jQuery('#plano_cultura_false').prop('checked', !this.inscricao.plano_cultura);
		jQuery('#plano_cultura_true').prop('checked', this.inscricao.plano_cultura);
		jQuery("form :input").prop("disabled", !this.edit);
	}
	
	ngOnDestroy() {
    }
}



// WEBPACK FOOTER //
// ./src/app/inscricao-detail/inscricao-detail.component.ts